import { KlaviyoInstanceIdentifierEnum } from '@repo/klaviyo/config'
import { ShopifyInstanceIdentifierEnum } from '@repo/shopify/config'
import { Language, Locale, LocaleIdentifier, MarketIdentifier, MarketInstance } from './types'

const english: Language = {
  tag: 'en',
  name: 'English',
}

export const markets: Readonly<MarketInstance[]> = [
  {
    id: MarketIdentifier.INT,
    name: 'International',
    currency: 'EUR',
    isDefault: true,
    shopifyInstance: ShopifyInstanceIdentifierEnum.EUR,
    klaviyoInstance: KlaviyoInstanceIdentifierEnum.EU,
    locales: [
      {
        id: 'en',
        name: 'English (International)',
        abbreviation: 'EN',
        language: english,
      },
    ],
  },
  {
    id: MarketIdentifier.GB,
    name: 'Great Britain',
    currency: 'GBP',
    isDefault: false,
    shopifyInstance: ShopifyInstanceIdentifierEnum.GBP,
    klaviyoInstance: KlaviyoInstanceIdentifierEnum.UK,
    locales: [
      {
        id: 'en-GB',
        name: 'English (Great Britain)',
        abbreviation: 'EN (GB)',
        language: english,
      },
    ],
    countries: [
      'GB', // United Kingdom (England, Scotland, Wales, Northern Ireland)
      'IE', // Ireland (Republic of Ireland, separate from the UK)
      'IM', // Isle of Man (self-governing British Crown Dependency)
      'JE', // Jersey (self-governing British Crown Dependency in the Channel Islands)
      'GG', // Guernsey (self-governing British Crown Dependency in the Channel Islands)
    ],
  },
  {
    id: MarketIdentifier.US,
    name: 'United States',
    currency: 'USD',
    isDefault: false,
    shopifyInstance: ShopifyInstanceIdentifierEnum.USD,
    klaviyoInstance: KlaviyoInstanceIdentifierEnum.US,
    locales: [
      {
        id: 'en-US',
        name: 'English (United States)',
        abbreviation: 'EN (US)',
        language: english,
      },
    ],
    countries: [
      'US', // United States
      'CA', // Canada
      'PR', // Puerto Rico (US territory)
      'VI', // United States Virgin Islands (US territory)
      'GU', // Guam (US territory)
      'MP', // Northern Mariana Islands (US territory)
      'AS', // American Samoa (US territory)
      'BM', // Bermuda (British Overseas Territory)
      'GL', // Greenland (Denmark territory)
    ],
  },
]

export const defaultMarketInstance: MarketInstance = markets.find((market) => market.id === MarketIdentifier.INT)!
export const defaultLocale: Locale = defaultMarketInstance.locales[0]!
export const locales: LocaleIdentifier[] = markets.flatMap((market) => market.locales.map((locale) => locale.id))

export const marketInstanceByLocaleIdentifier = (locale: LocaleIdentifier): MarketInstance => {
  const marketInstance = markets.find((market) => market.locales.some((l) => l.id === locale))

  if (!marketInstance) {
    throw new Error('Unknown market.')
  }

  return marketInstance
}

export const marketInstanceByShopifyIdentifier = (id: ShopifyInstanceIdentifierEnum): MarketInstance => {
  const marketInstance = markets.find((market) => market.shopifyInstance === id)

  if (!marketInstance) {
    throw new Error('Unknown market.')
  }

  return marketInstance
}

export const validateLocale = (potentialLocale: unknown): LocaleIdentifier => {
  const locale = locales.find((l) => l === potentialLocale)

  if (!locale) {
    throw new Error('Unknown locale.')
  }

  return locale
}
